export default __webpack_public_path__ + "8f76790afb7acf5dd17dc0d8036c75e4.svg";